export const VISUAL_FILTERS_DEFAULT_STEP_INDEX = 0;
